export type WatermarkedFile = {
  fileId: number | null
  totalNbPages: number
  pages: any[]
}

export type WatermarkedDialogData = {
  file: any
  isOpen: boolean
}

export type FilesState = {
  filePendingIds: number[]
  fileError: string | null
  watermarkedFilePendingPages: any[]
  watermarkedFile: WatermarkedFile
  watermarkedFileError: string | null
  watermarkedDialogData: WatermarkedDialogData
  watermarkedRequestPending: any[]
}

export const state: FilesState = {
  filePendingIds: [],
  fileError: null,
  watermarkedFilePendingPages: [],
  watermarkedFile: {
    fileId: null,
    totalNbPages: 0,
    pages: [],
  },
  watermarkedFileError: null,
  watermarkedDialogData: {
    file: null,
    isOpen: false,
  },
  watermarkedRequestPending: [],
}
